export default __webpack_public_path__ + "static/media/TeleConnect.354c4cd2.png";